import { render } from "./ResultInterstitialCTA.vue?vue&type=template&id=76d32a8e&ts=true"
import script from "./ResultInterstitialCTA.vue?vue&type=script&lang=ts"
export * from "./ResultInterstitialCTA.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__